<footer>
  <div class="container">
      <div class="subscribe-area">
          <div class="section-title">
              <h2>Subscribe Newsletter</h2>
          </div>

          <!-- <div class="subscribe-shape">
              <img src="assets/img/shape/1.png" alt="Shape">
              <img src="assets/img/shape/1.png" alt="Shape">
              <img src="assets/img/shape/1.png" alt="Shape">
              <img src="assets/img/shape/1.png" alt="Shape">
              <img src="assets/img/shape/2.png" alt="Shape">
          </div> -->

          <div class="subscribe-item">
              <form [formGroup]="footerform" (ngSubmit)="saveData()" class="newsletter-form">
                  <input type="email" class="form-control" placeholder="Enter Your Email" formControlName="email" required autocomplete="off">
                  <button class="btn subscribe-btn" type="submit">Subscribe</button>
              </form>
          </div>
      </div>

      <div class="row">
          <div class="col-sm-6 col-lg-3">
              <div class="footer-item">
                  <div class="footer-logo">
                    <!-- <h3>About Us</h3> -->
                    <a routerLink="/"><img src="assets/img/home/trepez_icon.png" alt="Trepez"></a>
                      <p>trepez is a platform that connects various clients to intending and reliable service providers. With few clicks, you can connect with quality service.</p>
                      <ul>
                          <li><a href="#" target="_blank"><i class="icofont-youtube-play"></i></a></li>
                          <li><a href="https://web.facebook.com" target="_blank"><i class="icofont-facebook"></i></a></li>
                          <li><a href="https://www.instagram.com/@trepez_link" target="_blank"><i class="icofont-instagram"></i></a></li>
                          <li><a href="https://www.twitter.com/@trepez_link" target="_blank"><i class="icofont-twitter"></i></a></li>
                      </ul>
                  </div>
              </div>
          </div>

          <div class="col-sm-6 col-lg-3">
              <div class="footer-item">
                  <div class="footer-category">
                      <h3>Category</h3>

                      <ul>
                          <li><a routerLink="/"><i class="icofont-simple-right"></i> Techincians & Mechanics</a></li>
                          <li><a routerLink="/"><i class="icofont-simple-right"></i> Photography</a></li>
                          <li><a routerLink="/"><i class="icofont-simple-right"></i> Tech & IT</a></li>
                          <li><a routerLink="/"><i class="icofont-simple-right"></i> Fashion & Clothing</a></li>
                          <li><a routerLink="/"><i class="icofont-simple-right"></i> Pets & Vets</a></li>
                      </ul>
                  </div>
              </div>
          </div>

          <div class="col-sm-6 col-lg-3">
              <div class="footer-item">
                  <div class="footer-category">
                      <h3>Quick Links</h3>

                      <ul>
                          <li><a routerLink="/"><i class="icofont-simple-right"></i> Home</a></li>
                          <li><a routerLink="/about_us"><i class="icofont-simple-right"></i> About Us</a></li>
                          <li><a routerLink="/work_in_progress"><i class="icofont-simple-right"></i> Service Providers</a></li>
                          <li><a routerLink="/contact"><i class="icofont-simple-right"></i> Contact Us</a></li>
                          <!-- <li><a routerLink="/"><i class="icofont-simple-right"></i> Testimonials</a></li> -->
                      </ul>
                  </div>
              </div>
          </div>

          <div class="col-sm-6 col-lg-3">
              <div class="footer-item">
                  <div class="footer-find">
                      <h3>Find Us</h3>

                      <ul>
                          <li><i class="icofont-location-pin"></i>60 Ikot-Ekpene Road</li>
                          <li><i class="icofont-ui-call"></i> <a href="tel:+2348033778219">+234 8033778219</a></li>
                          <li><i class="icofont-ui-email"></i> <a href="mailto:enquires@trepez.com">enquires@trepez.com</a></li>
                      </ul>
                  </div>
              </div>
          </div>
      </div>

      <div class="copyright-area">
          <div class="row">
              <div class="col-lg-6">
                  <div class="copyright-item">
                      <p>@2021 trepez.com </p>
                  </div>
              </div>

              <div class="col-lg-6">
                  <div class="copyright-item copyright-right">
                      <ul>
                          <li><a routerLink="/work_in_progress" target="_blank">Terms & Conditions</a></li>
                          <li><span>-</span></li>
                          <li><a routerLink="/work_in_progress" target="_blank">Privacy Policy</a></li>
                      </ul>
                  </div>
              </div>
          </div>
      </div>
  </div>
</footer>
